import { FormControlLabel, Switch } from '@mui/material';
import React from 'react';
import styled from 'styled-components';

interface CustomSwitchProps {
	title: string;
	color: string;
	checked: boolean;
	onToggle: (checked: boolean) => void;
	disabled?: boolean;
}

const StyledSwitch = styled(Switch)``;

const SwitchContainer = styled.div`
	display: flex;
	align-items: center;
`;

const Label = styled.span`
	margin-right: 8px;
`;

const CustomSwitch: React.FC<CustomSwitchProps> = ({
	title,
	color,
	checked,
	onToggle,
	disabled = false,
}) => {
	const handleChange = () => {
		onToggle(!checked);
	};

	return (
		<SwitchContainer>
			<Label>{title}</Label>
			<FormControlLabel
				control={
					<StyledSwitch
						checked={checked}
						color={color}
						onChange={handleChange}
						disabled={disabled}
					/>
				}
				label=""
			/>
		</SwitchContainer>
	);
};

export default CustomSwitch;
